<div class="page-content">
  <app-page-header
    [headline]="'DEFINE.COMPANY_FIT.TITLE'"
    [subheadline]="'DEFINE.COMPANY_FIT.SUBTITLE'"
    [spaceName]="space?.name || ''">
    <ng-content></ng-content>
  </app-page-header>

  <div class="page-scroll-content">
    <app-notes [visible]="showNotes"></app-notes>
    @if (space) {
      <app-company-profile
        [selectedIndustries]="normalizedIndustries"
        [selectedDisciplines]="space.disciplines"
        [selectedMaterials]="space.relevantMaterials"
        (selectedIndustriesChange)="onIndustriesChange($event)"
        (selectedDisciplinesChange)="onDisciplinesChange($event)"
        (selectedMaterialsChange)="onMaterialsChange($event)">
      </app-company-profile>
      <app-solution-portfolio
        [selectedCountry]="space.country"
        [selectedIndustries]="normalizedIndustries"
        [selectedDisciplines]="space.disciplines"
        [selectedMaterials]="space.relevantMaterials"
        [initialSelections]="initialSolutions"
        (selectedSolutionNamesChange)="onSelectedSolutionsChange($event)"
        (suggestedEditionIdsChange)="onSuggestedEditionIdsChange($event)">
      </app-solution-portfolio>
      <app-editions [suggestedEditionIds]="suggestedEditionIds"></app-editions>
    }

    <app-page-footer></app-page-footer>
  </div>
</div>
